"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Biv;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Biv(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "biv",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "key",
    d: "M76.3,56.7c0-5.9-4.7-10.6-10.6-10.6c-5.4,0-9.8,4-10.5,9.2l-34.1-0.1c-0.4,0-0.7,0.2-1,0.5 c-0.3,0.3-0.4,0.7-0.5,1l0,8.7c0,0.4,0.2,0.7,0.5,1c0.3,0.3,0.6,0.5,1,0.5c0.8,0,1.5-0.7,1.4-1.4l0-7.2l4.1,0l0,5.5 c0,0.4,0.2,0.7,0.5,1c0.3,0.3,0.6,0.5,1,0.5c0.8,0,1.5-0.7,1.4-1.4l0-5.7l25.6,0.1c0.3,2.3,1.4,4.5,3,6c1.9,1.9,4.6,3.1,7.5,3.1 C71.5,67.3,76.2,62.6,76.3,56.7z M65.7,64.4c-4.2,0-7.7-3.5-7.7-7.7s3.5-7.7,7.7-7.7c2.1,0,4,0.9,5.4,2.3c1.4,1.4,2.2,3.3,2.3,5.4 C73.4,61,69.9,64.4,65.7,64.4z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "home"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.2,48L54.9,3.7c-2.7-2.7-7.1-2.7-9.8,0L0.8,48c-1.2,1.2-1.2,3.1,0,4.1c1.2,1.2,3.1,1.2,4.1,0L49.2,7.9 c0.4-0.4,1.1-0.4,1.4,0l44.3,44.3c0.6,0.6,1.3,0.8,2.1,0.8c0.8,0,1.5-0.2,2.1-0.8C100.3,51.1,100.3,49.2,99.2,48z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.1,14.8c-1.2-1.2-3.1-1.2-4.1,0L9.5,53.1c-0.6,0.6-0.8,1.3-0.8,2.1v40.2c0,1.6,1.3,2.9,2.9,2.9h25.1 c1.6,0,2.9-1.3,2.9-2.9V76.6h19.8v18.8c0,1.6,1.3,2.9,2.9,2.9h26.1c1.6,0,2.9-1.3,2.9-2.9V55.2c0-0.8-0.4-1.5-0.8-2.1L52.1,14.8z M85.5,92.5H65.3V73.5c0-1.6-1.3-2.9-2.9-2.9H36.7c-1.6,0-2.9,1.3-2.9,2.9v18.8H14.6v-36L50,21l35.4,35.3V92.5z"
  })));
}